<template>
  <b-overlay :show="isUpload" rounded="sm">
    <div class="
        justify-content-md-center
        p-3
        d-flex
        flex-column
        justify-content-between
        h-100
      " :style="userData.isAndroid ? '' : 'overflow-y: scroll;'">
      <div>
        <b-row class="my-3">
          <b-col>
            <span class="text-ktb-bold-20"><span>Statement จากบัญชีกรุงไทย</span></span>
          </b-col>
        </b-row>
        <b-row v-for="(item, key) in lstDescription" :key="key" class="my-2">
          <b-col cols="1">
            <b-badge pill variant="primary"><span class="text-center badge-ktb-info" style="
                  position: absolute;
                  top: 20%;
                  left: 40%;
                  line-height: 12px;
                ">
                {{ key + 1 }}
              </span></b-badge>
          </b-col>
          <b-col align-self="end">
            <span class="mx-2 text-ktb-regular-16 align-bottom" style="line-height: 1">
              {{ item }}</span>
          </b-col>
          <div class="w-100" />
        </b-row>

        <div class="w-100 border-top-NEXT my-4" />
        <div v-if="lstAccount.length > 0">
          <b-row>
            <b-col>
              <span class="text-ktb-bold-16">บัญชีที่ต้องการขอ Statement</span>
            </b-col>
          </b-row>
          <b-row class="mt-2 mb-3" v-if="lstAccount.length > 1">
            <b-col>
              <span class="text-ktb-regular">เลือกได้มากกว่า 1 บัญชี</span>
            </b-col>
          </b-row>
          <div v-if="lstAccount.length == 1">
            <b-card v-for="item in lstAccount" :key="item.accountNo" :class="'border-radius-1rem ' +
              (isCardActive(item)
                ? ''
                : '' +
                ' ' +
                (checkEnable(item) ? 'card-disabled' : 'card-enabled'))
              " style="margin-top: 8pt" :body-class="'p-3 ' + (checkEnable(item) ? 'paleGrey cantClick' : 'canClick')
                ">
              <b-row>
                <b-col cols="2" class="pt-2" style="padding-right: 0%">
                  <b-img-lazy class="image w-100" :src="imgNEXT"></b-img-lazy>
                </b-col>
                <b-col cols="10">
                  <b-row class="upload-type">
                    <b-col :class="checkEnable(item)
                        ? 'text-ktb-bold-16-disabled'
                        : 'text-ktb-bold-16'
                      " align-self="center">
                      {{ item.accountName }}</b-col>
                    <div class="w-100" />
                    <b-col :class="checkEnable(item)
                        ? 'text-ktb-regular-disabled'
                        : 'text-ktb-regular'
                      " align-self="center">
                      {{ covertAccountType(item.productGrp) }}
                      {{ patternAccount(item.accountNo) }}</b-col>
                    <div class="w-100" />
                    <b-col align-self="center">
                      <span :class="checkEnable(item)
                          ? 'text-ktb-bold-24-disabled'
                          : 'text-ktb-bold-24'
                        ">
                        {{ Number(item.balance).toLocaleString() }}
                      </span>
                      <span :class="checkEnable(item)
                          ? 'text-ktb-bold-16-disabled'
                          : 'text-ktb-bold-16'
                        ">
                        THB</span>
                    </b-col>
                    <template v-if="checkEnable(item)">
                      <div class="w-100" />
                      <b-col class="text-ktb-regular-14-red" align-self="center">
                        {{ item.errorMsg }}</b-col>
                    </template>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div v-if="lstAccount.length > 1">
            <b-card v-for="item in lstAccount" :key="item.accountNo" :class="'border-radius-1rem ' +
              (isCardActive(item)
                ? 'card-active'
                : '' +
                ' ' +
                (checkEnable(item) ? 'card-disabled' : 'card-enabled'))
              " style="margin-top: 8pt" :body-class="'p-3 ' + (checkEnable(item) ? 'paleGrey cantClick' : 'canClick')
                " @click="onSelected(item)">
              <b-row>
                <b-col cols="">
                  <b-row class="upload-type">
                    <b-col :class="checkEnable(item)
                        ? 'text-ktb-bold-16-disabled'
                        : 'text-ktb-bold-16'
                      " align-self="center">
                      {{ item.accountName }}</b-col>
                    <div class="w-100" />
                    <b-col :class="checkEnable(item)
                        ? 'text-ktb-regular-disabled'
                        : 'text-ktb-regular'
                      " align-self="center">
                      {{ covertAccountType(item.productGrp) }}
                      {{ patternAccount(item.accountNo) }}</b-col>
                    <div class="w-100" />
                    <b-col align-self="center">
                      <span :class="checkEnable(item)
                          ? 'text-ktb-bold-24-disabled'
                          : 'text-ktb-bold-24'
                        ">
                        {{ Number(item.balance).toLocaleString() }}
                      </span>
                      <span :class="checkEnable(item)
                          ? 'text-ktb-bold-16-disabled'
                          : 'text-ktb-bold-16'
                        ">
                        THB</span>
                    </b-col>
                    <template v-if="checkEnable(item)">
                      <div class="w-100" />
                      <b-col class="text-ktb-regular-14-red" align-self="center">
                        {{ item.errorMsg }}</b-col>
                    </template>
                  </b-row>
                </b-col>
                <b-col cols="auto" class="d-flex justify-content-center">
                  <div class="custom-control custom-checkbox">
                    <input :value="item.accountNo" v-model="accountSelected" :disabled="checkEnable(item)"
                      type="checkbox" class="custom-control-input" :id="'customCheck' + item.accountNo" />
                    <label class="custom-control-label" for="customCheck1"></label>
                  </div>
                </b-col>
              </b-row>
            </b-card>
          </div>

          <div class="w-100 border-top-NEXT my-4" />
          <b-row class="my-3">
            <b-col>
              <b-card class="border-radius-1rem" body-class="card-body-padding">
                <b-card-text>
                  <b-row style="line-height: 24px">
                    <b-col class="px-3 text-ktb-regular"><span
                        style="vertical-align: bottom">รายการบัญชีระหว่างวันที่</span></b-col>
                    <b-col class="px-0 text-ktb-bold-16"><span style="vertical-align: bottom">{{
                      periodStatementKtb
                        }}</span></b-col>
                  </b-row>
                </b-card-text>
              </b-card>
            </b-col>
          </b-row>
        </div>
      </div>
      <div v-if="lstAccount.length > 0">
        <b-row v-if="lstAccount.length > 1">
          <b-col align-self="center">
            <button @click="onSubmit()" :disabled="checkDocIsSuccess() || checkLstAccountDisable()"
              :class="'btn btn-info btn-block btn-ktb-' + userData.channel">
              {{ "ดำเนินการต่อ" }}
            </button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col align-self="center">
            <button v-if="
              (userData.accountSelected != undefined &&
                userData.accountSelected.length == 0) ||
              userData.accountSelected === undefined
            " @click="onSubmit()" :disabled="checkDocIsSuccess() || checkLstAccountDisable()"
              :class="'btn btn-info btn-block btn-ktb-' + userData.channel">
              {{ "ดำเนินการต่อ" }}
            </button>
            <button v-else @click="onCancelStatement()" :disabled="checkDocIsSuccess() || checkLstAccountDisable()"
              class="btn btn-info btn-block btn-ktb-NEXT btn-cancel-dstatement">
              {{ "ยกเลิก statement" }}
            </button>
          </b-col>
        </b-row>
      </div>
    </div>
  </b-overlay>
</template>
<script>
import axios from "axios";
export default {
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  async created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    const fnSet = this.setIsLoading;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      timeout: this.timeout,
      headers: { Authorization: this.userData.uuid },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        fnSet(true);
        return config;
      },
      function (error) {
        fnSet(false);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        fnSet(false);
        return response;
      },
      function (error) {
        fnSet(false);
        return Promise.reject(error);
      }
    );

    let currentMenu = {
      pageCode: "CommonListAccount",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      ).grp_name,
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
    };
    this.$event.$emit("update_current_menu", currentMenu);
    if (this.userData.listAccount != undefined) {
      this.lstAccount = this.userData.listAccount;
    } else {
      await this.getAccountCBS();
    }
    if (
      this.userData.accountSelected != undefined &&
      this.userData.accountSelected.length != 0
    ) {
      this.accountSelected = this.userData.accountSelected;
    } else {
      if (this.lstAccount.length == 1) {
        this.onSelected(this.lstAccount[0]);
      }
    }

    if (this.$route.params.checkDocIsSuccess != undefined) {
      this.checkStateSuccess = this.$route.params.checkDocIsSuccess;
    }
    this.periodStatementKtb = this.userData.periodStatementKtb;
    this.lstDescription = [];
    try {
      if (
        ("1083" == this.userData.marketCode &&
          "2011" == this.userData.productType) ||
        ("1099" == this.userData.marketCode &&
          "7002" == this.userData.productType)
      ) {
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        let docCode = document_group_type.lst_doc_id[0];
        const docType = this.userData.documentType.find(
          (item) => item.doc_code == docCode
        );
        this.lstDescription.push(docType.doc_short_name);
      } else {
        this.lstDescription.push(
          "มีข้อมูลย้อนหลัง " + this.userData.monthCalc + " เดือน"
        );
      }
    } catch (err) {
      this.lstDescription.push("มีข้อมูลย้อนหลัง 6 เดือน");
    }
    this.scaleUpCheckbox();
  },
  data() {
    return {
      checkStateSuccess: false,
      imgNEXT: require("@/assets/images/BankLogo/KTB.png"),
      lstDescription: [],
      accountSelected: [],
      lstAccount: [],
      objAcc: null,
      urlapi: process.env.VUE_APP_APIURL,
      axiosInstance: null,
      periodStatementKtb: "",
      isUpload: false,
    };
  },
  methods: {
    scaleUpCheckbox() {
      let checkboxs = document.getElementsByClassName("custom-control-label");
      // let c1 = checkboxs[0]
      document.styleSheets[0].addRule(
        "custom-control-label:before",
        "width: 24px"
      );

      console.log(`checkboxs`, checkboxs);
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    goToListAccount() {
      this.$router.push({
        name: this.userData.routerPath.listAccount,
      });
    },
    covertAccountType_tmp(accountType) {
      switch (accountType) {
        case "1":
          return "ออมทรัพย์";
        case "2":
          return "กระแสรายวัน";
        default:
          return "not found";
      }
    },
    covertAccountType(productGrp) {
      switch (productGrp) {
        case "SAV":
          return "ออมทรัพย์";
        default:
          return "กระแสรายวัน";
        // default:
        //   return "not found";
      }
    },
    checkEnable(item) {
      return item.errorMsg != undefined && item.errorMsg != "";
    },
    isCardActive(item) {
      return this.accountSelected.includes(item.accountNo);
    },
    onSelected(item) {
      if (this.checkEnable(item)) return;
      if (this.isCardActive(item)) {
        const index = this.accountSelected.indexOf(item.accountNo);
        if (index > -1) {
          this.accountSelected.splice(index, 1);
        }
      } else {
        this.accountSelected.push(item.accountNo);
      }
    },
    onSubmit() {
      if (this.lstAccount.length == 1 && this.accountSelected.length == 0)
        this.onSelected(this.lstAccount[0]);
      this.userData.listAccount = this.lstAccount;
      this.userData.accountSelected = this.accountSelected;
      this.$store.dispatch("setUserData", this.userData);
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    onCancelStatement() {
      this.accountSelected = [];
      this.userData.listAccount = this.lstAccount;
      this.userData.accountSelected = [];
      this.$store.dispatch("setUserData", this.userData);
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    async getAccountCBS() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }

      //  let response =
      this.axiosInstance({
        method: "GET",
        url: "/api/accountInfo?docIdStatement=" + docIdStatement,
      })
        .then((response) => {
          this.userData.listAccount = response.data;
          this.$store.dispatch("setUserData", this.userData);
          this.lstAccount = this.userData.listAccount;
          // return response;
          if (this.lstAccount.length == 1) {
            this.onSelected(this.lstAccount[0]);
          }
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    checkDocIsSuccess() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let docType = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      );
      return docType.state != undefined && docType.state == "success";
    },
    checkLstAccountDisable() {
      return (
        this.lstAccount.length == 1 &&
        this.lstAccount[0].errorMsg != undefined &&
        this.lstAccount[0].errorMsg != ""
      );
    },
    patternAccount(value) {
      return (
        value.substring(0, 3) +
        "-" +
        value.substring(3, 4) +
        "-" +
        value.substring(4, 9) +
        "-" +
        value.substring(9, 10)
      );
    },
  },
};
</script>

<style scoped>
.paleGrey {
  background-color: #eaf0f5;
  border-radius: 1em !important;
}

.cantClick {
  cursor: not-allowed;
}

.card-active {
  background-color: rgb(223, 241, 252) !important;
  border: 1px solid rgb(0, 166, 230) !important;
}

.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.card-enabled {
  border: 0.5px solid rgba(151, 151, 151, 0.5) !important;
}

.card-disabled {
  border: 0px !important;
}

.custom-control-label::before {
  width: 24px !important;
  height: 24px !important;
}

.custom-control-label::after {
  width: 24px !important;
  height: 24px !important;
}

.btn-cancel-dstatement {
  color: rgb(219, 0, 0) !important;
  border-color: rgb(219, 0, 0) !important;
  background-color: white !important;
  background-image: unset !important;
}

.card-body-padding {
  padding: 1rem !important;
  padding-top: 19px !important;
}

.custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  background-image: url("~@/assets/icons/svg/correct-white.svg") !important;
}

.custom-checkbox .custom-control-input:disabled:checked~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-input:disabled~.custom-control-label::before {
  background-color: #bdcbd6 !important;
  border-color: #bdcbd6 !important;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
  border: rgb(0, 166, 230) solid 1px !important;
}

.custom-control-input:checked~.custom-control-label::before {
  border-color: #03a5e6 !important;
  background-color: #03a5e6 !important;
}
</style>
